module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAPVJREFUSEvt1b0OgjAQB/AegxIfRZ9HEgcHdHGByddwsYOTMjiYwPPooxh04AwkxfIhtAfCUsamdz/6b9oCG+mDkVxm4MGSN1ErR/1yvXk6eRrwh3KRNJEUdYZaVpj1SRKHgmvDAkXEReoCwJ2Ca8FlVCRHwZXhCooYZTDAkrJyJbgOtQPupGDseiEFb4WbUBE1BW+EVVAq/hPWQSl4LUxBdfEK3AXVwQtwH6gqnsN9oip4YcXxxt8xxk4MMRLnlPIAyDXfo4Z7+8IP+W1Xbvx0vdUs4LeuoFz/3vrryfl4lcdaL5A+f8DA/0qzsa/Z48FiHy3qD3E71B9uLSjDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/red_top_arrows.png
// module id = X9LL
// module chunks = 3